<template>
  <div class="tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1">
    <span class="tw-text-[12px] tw-font-normal tw-text-[#211F58] tw-px-2">
      {{ title }}
    </span>
  </div>
  <div
    v-if="isShowDetail"
    class="tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-px-2 tw-py-1 tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]"
  >
    <textarea
      ref="inputRef"
      v-model="detailRef"
      type="text"
      readonly
      disabled
      class="tw-text-[12px] tw-font-normal tw-text-[#878787] tw-w-full tw-border-0 !tw-bg-white tw-resize-none tw-overflow-hidden"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";

const props = defineProps<{
  title?: string;
  detail?: string;
  isShowDetail?: boolean;
}>();

const detailRef = ref("");
const inputRef = ref<HTMLTextAreaElement | null>(null);

const calHeight = () => {
  setTimeout(() => {
    if (!inputRef.value) {
      return;
    }
    inputRef.value.style.height = `${inputRef.value.scrollHeight}px`;
  }, 1);
};

onMounted(() => {
  detailRef.value = props.detail || "";
  calHeight();
});

watch(
  () => [props.detail, props.isShowDetail],
  () => {
    detailRef.value = props.detail || "";
    calHeight();
  },
);
</script>
